var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-create__section"},[_c('ShippingDetailsBlock',{attrs:{"ordersInbound":_vm.ordersInbound,"personal":_vm.ordersInbound.data.Personal,"delivery":_vm.ordersInbound.data.Delivery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }